import React, { useRef } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import AgGridDataTable from "../../shared/utilities/AgGridDataTable";


const TransporterTerminalLocations = (props) => {
  const agGridRef = useRef();
  const columnDefs = [
    {
        headerName: "Facility Address", field: "FAC_ADDRESS", width: 130,
    },
    {
        headerName: "City", field: "FAC_CITY", width: 90,
    },
    {
        headerName: "County", field: "FAC_CNTY", width: 90,
    },
    {
        headerName: "State", field: "FAC_ST", width: 40,
    },
    {
        headerName: "Zip Code", field: "FAC_ZIP", width: 80,
    },
    {
        headerName: "Date Created", field: "CREATE_DATE", width: 90,
    },
    {
        headerName: "Date Last Updated", field: "UPDATE_DATE", width: 100,
    },
  ];

  return (

      <div className="facility-address-card">
     <h3
          style={{
            textAlign: "center",
          }}
        >
          Transporter Terminal Locations
        </h3>
        {props.transLocs.length == 0 ? <div>No Terminal Locations associated with this Transporter Registration.</div> 
        : 
        
        <div>
          <AgGridDataTable
            pageTitle={`Transporter Profile: ${props.transName} (${props.regID})`}
            agGridRef={agGridRef}
            columnDefs={columnDefs}
            rowData={props.transLocs}
            initialPageSize={10}
            hidePagination={true}
          />
        </div>
        }
      </div>
     
  );
};

export default TransporterTerminalLocations;
